/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import H2 from 'UIComponents/elements/headings/H2';
import { NavMarker } from 'react-rhumb';
import { useLatestSavedItemsInteractions, usePlaylist } from '../../savedItems';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { theme } from 'academy-common-lib/utils/Styling';
import I18n from 'I18n';
import { HasScope, useAccounts } from '../../accounts';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { Field, Form, useForm } from 'react-final-form';
import { FinalFormField } from '../../../components/FinalForm';
import UIForm from 'UIComponents/form/UIForm';
import { useCallback } from 'react';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import { required } from '../../../utils/validation';
import Small from 'UIComponents/elements/Small';
import UISelect from 'UIComponents/input/UISelect';
import { useCreatePlaylistAssignment, usePlaylistAssignments, usePlaylistAssignmentsParams, useUpdatePlaylistAssignments } from '../';
import useNavigate from '../../../hooks/useNavigate';
import UIAlert from 'UIComponents/alert/UIAlert';
import ErrorBoundary from '../../../components/Errors/ErrorBoundary';
import { fromDateToUiDateInputFormat, fromUiDateInputFormatToUnixTs } from '../../../utils/CanvasComponents';
import { getAssignmentsForPortalUrl, getPortalAssignmentsUrl } from '../playlistAssignmentsRouting';
import { Redirect } from 'react-router-dom';
import UITextInput from 'UIComponents/input/UITextInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UITooltip from 'UIComponents/tooltip/UITooltip';
const tomorrowDate = new Date();
tomorrowDate.setDate(new Date().getDate() + 1);
const AccountsTabs = ({
  myAccounts,
  allAccounts
}) => {
  const form = useForm();
  const formState = form.getState();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Field, {
      name: "accountsRadio",
      render: ({
        input
      }) => /*#__PURE__*/_jsxs(UIToggleGroup, {
        className: "p-top-3",
        name: "accountsRadio",
        children: [/*#__PURE__*/_jsx(UIRadioInput, Object.assign({}, input, {
          defaultChecked: true,
          inline: true,
          value: "myAccounts",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.myAccounts"
          })
        })), /*#__PURE__*/_jsxs(UIRadioInput, Object.assign({}, input, {
          inline: true,
          value: "allAccounts",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.allAccounts"
          }), /*#__PURE__*/_jsx(UITooltip, {
            placement: "bottom",
            title: I18n.text('learningCenter.playlists.allAccountsTooltip'),
            children: /*#__PURE__*/_jsx(UIIcon, {
              className: "m-left-1",
              color: theme.colors.HEFFALUMP,
              name: "info",
              size: 14
            })
          })]
        }))]
      })
    }), formState.values.accountsRadio === 'allAccounts' ? allAccounts : formState.values.accountsRadio === 'myAccounts' ? myAccounts : null]
  });
};
import { HubSpotterAccountUsersSelect } from './HubSpotterAccountUsersSelect';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ServerError = ({
  error
}) => {
  if (!error) return null;
  return /*#__PURE__*/_jsxs(UIAlert, {
    className: "m-bottom-3",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.somethingsGoneWrong"
    }),
    type: "danger",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.refreshPage"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.keepsHappening"
    })]
  });
};
const HubSpotterPortalUserAssign = ({
  isMultiUserAccount,
  isEditing,
  accountId,
  accounts
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'account'
      },
      formControlProps: {
        className: 'm-top-7',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignPortal"
        })
      },
      hidden: !isMultiUserAccount,
      render: input => /*#__PURE__*/_jsx(UITextInput, Object.assign({}, input, {
        disabled: accounts.length === 1 || isEditing,
        inputMode: "numeric",
        type: "text"
      })),
      validators: [required]
    }), /*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'assignees'
      },
      formControlProps: {
        className: 'm-top-7',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignAssignee"
        })
      },
      render: input => /*#__PURE__*/_jsx(HubSpotterAccountUsersSelect, Object.assign({}, input, {
        accountId: accountId,
        disabled: isEditing
      })),
      validators: [required]
    })]
  });
};
const StandardPortalUserAssign = ({
  isMultiUserAccount,
  isEditing,
  accountId,
  accounts
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'account'
      },
      formControlProps: {
        className: 'm-top-7',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignPortal"
        })
      },
      hidden: !isMultiUserAccount,
      render: input => /*#__PURE__*/_jsx(UISelect, Object.assign({}, input, {
        disabled: accounts.length === 1 || isEditing,
        options: accounts.map(account => ({
          value: account.id,
          text: I18n.text('learningCenter.playlists.assignAccountNameAndId', {
            accountName: I18n.SafeString(account.accountName),
            accountId: account.id.toString()
          })
        }))
      })),
      validators: [required]
    }), /*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'assignees'
      },
      formControlProps: {
        className: 'm-top-7',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignAssignee"
        })
      },
      render: input => /*#__PURE__*/_jsx(HubSpotterAccountUsersSelect, Object.assign({}, input, {
        accountId: accountId,
        disabled: isEditing
      })),
      validators: [required]
    })]
  });
};
const PlaylistAssignImpl = ({
  playlistId
}) => {
  const {
    playlist
  } = usePlaylist(playlistId);
  const {
    portalId,
    assignmentIds
  } = usePlaylistAssignmentsParams();
  const isEditing = assignmentIds && !!assignmentIds.length;
  const {
    accounts
  } = useAccounts();
  const {
    playlistAssignments
  } = usePlaylistAssignments({
    playlistId,
    assignmentIds,
    portalId,
    skip: !isEditing
  });
  const {
    createPlaylistAssignment,
    createPlaylistAssignmentError
  } = useCreatePlaylistAssignment();
  const {
    updatePlaylistAssignments,
    updatePlaylistAssignmentsError
  } = useUpdatePlaylistAssignments();
  const navigate = useNavigate();
  const {
    setLatestInteraction
  } = useLatestSavedItemsInteractions();
  const closeDestination = portalId ? getAssignmentsForPortalUrl({
    portalId,
    playlistId
  }) : getPortalAssignmentsUrl({
    playlistId
  });
  const isMultiUserAccount = (accounts || []).length > 1;
  const onSubmit = useCallback(async formData => {
    const {
      dueDate,
      account,
      assignees
    } = formData;
    const dueDateUnixTs = dueDate ? fromUiDateInputFormatToUnixTs(dueDate) : undefined;
    if (!isEditing) {
      assignees.forEach(assignee => {
        UsageTracker.track('playlistInteraction', {
          action: 'playlist-assigned',
          playlistId,
          portalId,
          hubspotterId: assignee,
          bulk: assignees.length > 1,
          date: dueDateUnixTs
        });
      });
    }
    const response = isEditing ? await updatePlaylistAssignments({
      assignmentIds,
      dueDate: dueDateUnixTs
    }) : await createPlaylistAssignment({
      playlistId,
      portalId: account,
      assigneeUserIds: assignees,
      dueDate: dueDateUnixTs
    }).then(createdAssignments => {
      if (createdAssignments) {
        setLatestInteraction({
          playlistId,
          portalId: account,
          action: 'CREATE_PLAYLIST_ASSIGNMENT',
          assignmentIds: createdAssignments.map(assignment => assignment.id)
        });
      }
      return createdAssignments;
    });

    /**
     * If we receive a response, it means the request was successful.
     */
    if (response) {
      navigate(closeDestination);
    }
  }, [assignmentIds, closeDestination, createPlaylistAssignment, isEditing, navigate, playlistId, portalId, setLatestInteraction, updatePlaylistAssignments]);
  if (isEditing && playlistAssignments && !playlistAssignments.length) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: closeDestination
    });
  }
  let dueDate = null;
  if (playlistAssignments && playlistAssignments.length) {
    // gets due date from assignments (if all have the same)
    dueDate = playlistAssignments[0].dueDate;
    if (playlistAssignments.some(pa => pa.dueDate !== dueDate)) dueDate = null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [playlist && /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignPlaylistName",
          options: {
            playlistName: playlist.name
          }
        })
      }), /*#__PURE__*/_jsx(UIRouterButton, {
        "aria-label": I18n.text('learningCenter.common.close'),
        to: closeDestination,
        use: "unstyled",
        children: /*#__PURE__*/_jsx(UIIcon, {
          color: theme.colors.OLAF,
          name: "remove",
          size: 16
        })
      })]
    }), playlist && accounts && /*#__PURE__*/_jsx(Form, {
      initialValues: isEditing && playlistAssignments ? {
        assignees: playlistAssignments.map(pa => pa.assignee.userId),
        dueDate: dueDate ? fromDateToUiDateInputFormat(new Date(dueDate)) : null,
        accountsRadio: 'myAccounts',
        account: portalId
      } : {
        dueDate: null,
        account: portalId || accounts.length && accounts[0].id || null,
        accountsRadio: 'myAccounts'
      },
      onSubmit: onSubmit,
      render: ({
        handleSubmit,
        values: {
          account: accountId,
          accountsRadio
        }
      }) => /*#__PURE__*/_jsx(NavMarker, {
        name: "ASSIGN_PLAYLIST_LOADED",
        children: /*#__PURE__*/_jsxs(UIForm, {
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/_jsxs(UIDialogBody, {
            className: "p-top-5 p-left-8 p-right-9",
            children: [/*#__PURE__*/_jsx(ServerError, {
              error: createPlaylistAssignmentError || updatePlaylistAssignmentsError
            }), /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: accountsRadio === 'allAccounts' ? 'learningCenter.playlists.assignIntroductionPortalSearch' : isMultiUserAccount ? 'learningCenter.playlists.assignIntroductionMultiAccount' : 'learningCenter.playlists.assignIntroductionSingleAccount'
              })
            }), /*#__PURE__*/_jsx(HasScope, {
              fallback: /*#__PURE__*/_jsx(StandardPortalUserAssign, {
                accountId: accountId,
                accounts: accounts,
                isEditing: isEditing,
                isMultiUserAccount: isMultiUserAccount
              }),
              override: isEditing,
              scope: "academy-playlist-global-assignment",
              children: /*#__PURE__*/_jsx(AccountsTabs, {
                allAccounts: /*#__PURE__*/_jsx(HubSpotterPortalUserAssign, {
                  accountId: accountId,
                  accounts: accounts,
                  isEditing: isEditing,
                  isMultiUserAccount: isMultiUserAccount
                }),
                myAccounts: /*#__PURE__*/_jsx(StandardPortalUserAssign, {
                  accountId: accountId,
                  accounts: accounts,
                  isEditing: isEditing,
                  isMultiUserAccount: isMultiUserAccount
                })
              })
            }), /*#__PURE__*/_jsx(FinalFormField, {
              fieldProps: {
                name: 'dueDate',
                allowNull: true
              },
              formControlProps: {
                className: 'm-top-7',
                label: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.common.dueDate"
                })
              },
              render: input => /*#__PURE__*/_jsx(UIDateInput, Object.assign({}, input, {
                min: fromDateToUiDateInputFormat(new Date()),
                tz: "utc"
              }))
            }), /*#__PURE__*/_jsx(Small, {
              className: "display-block m-top-1",
              use: "help",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.playlists.assignDueDateHelpText"
              })
            })]
          }), /*#__PURE__*/_jsxs(UIDialogFooter, {
            children: [/*#__PURE__*/_jsx(UIButton, {
              type: "submit",
              use: "primary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.common.assign"
              })
            }), /*#__PURE__*/_jsx(UIRouterButton, {
              to: closeDestination,
              use: "secondary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.common.cancel"
              })
            })]
          })]
        })
      })
    })]
  });
};
export const PlaylistAssignPanel = ({
  playlistId
}) => {
  return /*#__PURE__*/_jsx(UIModalPanel, {
    width: 512,
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(PlaylistAssignImpl, {
        playlistId: playlistId
      })
    })
  });
};